import {inject, Injectable} from "@angular/core";
import {GetSavedDeliveryPointUseCase} from "@app/core/delivery-point/application/get-saved-delivery-point.use-case";
import {DeliveryPointRemote} from "@app/core/delivery-point/domain/delivery-point.remote";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {firstValueFrom, from, Observable} from "rxjs";

/**
 * Use case for updating the saved information about the selected delivery point.
 */
@Injectable({
    providedIn: 'root'
})
export class UpdateSelectedDeliveryPointUseCase {

    private getSavedDeliveryPointUseCase = inject(GetSavedDeliveryPointUseCase);
    private deliveryPointRemote = inject(DeliveryPointRemote);
    private deliveryPointLocal = inject(DeliveryPointLocal);

    execute(): Observable<void> {
        return from(this.updateSelectedDeliveryPoint());
    }

    private async updateSelectedDeliveryPoint() {
        const savedDeliveryPoint = this.getSavedDeliveryPointUseCase.execute();
        if (savedDeliveryPoint) {
            const deliveryPoint = await firstValueFrom(this.deliveryPointRemote.getDeliveryPoint(savedDeliveryPoint.code));
            this.deliveryPointLocal.saveDeliveryPoint(deliveryPoint);
        }
    }
}
